<button
    type="button"
    role="switch"
    class="btn switch"
    [class.active]="isActive"
    [attr.aria-checked]="isActive"
    [attr.aria-label]="ariaLabel"
    (click)="toggleActiveHandler($event)"
    [disabled]="disabled"
></button>
